module.exports = __webpack_public_path__ + "static/media/news.ab4a9cdc.png";